import React from 'react';
import SelectField from '../../../../FormikUtils/SelectField'
import {useFormikContext} from "formik";
import {Grid} from "@material-ui/core";

const vigencias = [
    {value: '1', label: 'Anual'},
];

const cantCuotas = [
    {value: '1', label: '1'},
    {value: '2', label: '2'},
    {value: '3', label: '3'},
    {value: '4', label: '4'},
    {value: '5', label: '5'},
];

const ajuste = [
    {value: '0', label: 'No aplicar'},
    {value: '10', label: 'Aplicar 10%'},
    {value: '20', label: 'Aplicar 20%'},
    {value: '30', label: 'Aplicar 30%'},
];

export default function CoberturaForm(props) {
    const {
        formField: {
            vigencia,
            cuotas,
            ajusteAutomatico,
        },
    } = props;
    const {values} = useFormikContext();

    return (
        <React.Fragment>
            <Grid container spacing={3}>
                <Grid item xs={12} sm={6}>
                    <SelectField
                        name={vigencia.name}
                        label={vigencia.label}
                        data={vigencias}
                        disabled
                        fullWidth
                        textTransform={'capitalize'}
                    />
                </Grid>

                {values.vigencia !== '1' && (
                    <Grid item xs={12} sm={6}>
                        <SelectField
                            name={cuotas.name}
                            label={cuotas.label}
                            data={cantCuotas}
                            fullWidth
                            textTransform={'uppercase'}
                        />
                    </Grid>
                )}

                {values.vigencia !== '1' && (
                    <Grid item xs={12} sm={6}>
                        <SelectField
                            name={ajusteAutomatico.name}
                            label={ajusteAutomatico.label}
                            data={ajuste}
                            fullWidth
                        />
                    </Grid>
                )}

            </Grid>
        </React.Fragment>
    );
}
